import { createContext, type PropsWithChildren, use, useMemo, useState } from 'react';
import { noop } from '@interxfi/utilities/fn/no-op';

const RealmIndicatorContext = createContext<{
  showBanner: boolean;
  setShowBanner: (show: boolean) => void;
}>({
  showBanner: true,
  setShowBanner: noop,
});

export function useRealmIndicatorContext() {
  return use(RealmIndicatorContext);
}

export function RealmIndicatorContextProvider({ children }: PropsWithChildren) {
  const [showBanner, setShowBanner] = useState(true);
  const value = useMemo(
    () => ({
      showBanner,
      setShowBanner,
    }),
    [showBanner],
  );

  return <RealmIndicatorContext.Provider value={value}>{children}</RealmIndicatorContext.Provider>;
}
